import type { AppContent } from './en';
import { en } from './en';

export type Locale = 'en';

const registry: Record<Locale, AppContent> = {
  en,
};

export function getContent(locale: Locale = 'en'): AppContent {
  return registry[locale] || en;
}

export type { AppContent };
